import React, { useContext } from "react";
import {
  Box,
  HStack,
  Text,
  VStack,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  Button,
  useBreakpointValue,
  Link,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faUser } from "@fortawesome/free-solid-svg-icons";
import { AuthContext } from "../context/AuthContext";

const UserLoginBox = () => {
  const { sessionId, login, profile, auth, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const isDesktop = useBreakpointValue({ base: false, md: true });
  const fontSize = "clamp(0.5rem, 2.2vw, 0.7rem)";
  const menuFontSize = "clamp(0.5rem, 2vw, 0.85rem)";

  //console.log("AuthContext in UserLoginBox:", { sessionId, login, profile });
  //console.log("AuthContext auth:", JSON.stringify(auth));
  const isStaff =
    auth.UserProfileType === "Employee" || auth.UserProfileType === "Admin";
  const userInfo =
    login && profile
      ? {
          name: profile.FirstName || "Guest",
          surname: profile.LastName || "",
          username: profile.Email || "guest",
          office: profile.OfficeID || "",
        }
      : {
          name: "Guest",
          surname: "",
          username: "guest",
        };

  const fullName = `${userInfo.name} ${userInfo.surname}`.trim();

  const handleLogoutClick = () => {
    if (logout) {
      logout();
      navigate("/login");
    }
  };

  const handleLoginClick = (type) => {
    if (type === "farmer") {
      navigate("/login");
    } else if (type === "staff") {
      navigate("/loginstaff");
    }
  };

  return (
    <Box p={{ base: 1, md: 1 }} borderRadius="md">
      <HStack spacing={{ base: 1, md: 2 }} align="center">
        {sessionId ? (
          <Menu>
            {isDesktop && (
              <Box ml={2} mr={2}>
                {/* [ปรับปรุง] ปรับ spacing และการจัดวาง */}
                <VStack spacing={0} align="flex-start">
                  {/* [ปรับปรุง] เปลี่ยนสีข้อความเป็นสีขาว และปรับความหนา */}
                  <Text fontSize={fontSize} fontWeight="medium" color="white">
                    {userInfo.name}
                  </Text>
                  <Text fontSize={fontSize} fontWeight="medium" color="white">
                    {userInfo.surname}
                  </Text>
                  {/* [ปรับปรุง] เพิ่มข้อมูลหน่วยงานด้วยสีที่อ่อนลงเล็กน้อย */}
                  <Text fontSize="xs" color="whiteAlpha.800">
                    {userInfo.office}
                  </Text>
                </VStack>
              </Box>
            )}
            <MenuButton
              as={IconButton}
              w="15px"
              size="sm"
              variant="ghost"
              color="white" // [ปรับปรุง] เปลี่ยนสีไอคอนเป็นสีขาว
              _hover={{ bg: "whiteAlpha.200" }} // [ปรับปรุง] ทำให้ hover effect เหมือนกับ TopMenu
              icon={
                isDesktop ? (
                  <FontAwesomeIcon icon={faChevronDown} size="sm" />
                ) : (
                  <FontAwesomeIcon icon={faUser} size="sm" />
                )
              }
            />
            {isStaff ? (
              <MenuList fontSize="sm">
                <MenuItem
                  fontSize={menuFontSize}
                  onClick={() => navigate("/profile")}
                >
                  ข้อมูลผู้ใช้
                </MenuItem>

                <MenuDivider />
                <MenuItem>
                  <Link href="/DLDUserManual.pdf" target="_new">
                    คู่มือการใช้งาน
                  </Link>
                </MenuItem>
                <MenuItem onClick={() => navigate("/trainingvideo")}>
                  วิดีโอการอบรม
                </MenuItem>
                <MenuDivider />
                <MenuItem fontSize={menuFontSize} onClick={handleLogoutClick}>
                  ออกจากระบบ
                </MenuItem>
              </MenuList>
            ) : (
              <MenuList fontSize="sm">
                <MenuItem
                  fontSize={menuFontSize}
                  onClick={() => navigate("/farmerprofile")}
                >
                  ข้อมูลผู้ใช้
                </MenuItem>
                <MenuDivider />
                <MenuItem fontSize={menuFontSize} onClick={handleLogoutClick}>
                  ออกจากระบบ
                </MenuItem>
              </MenuList>
            )}
          </Menu>
        ) : (
          <VStack spacing={2} align="flex-start">
            <Button
              size="sm"
              w="130px"
              fontSize={fontSize}
              onClick={() => handleLoginClick("farmer")}
              colorScheme="loginScheme" // [ปรับปรุง] ใช้ color scheme จาก theme เพื่อความสอดคล้อง
            >
              เข้าสู่ระบบสั่งจองวัคซีน
            </Button>
            <Button
              size="sm"
              w="130px"
              fontSize={fontSize}
              onClick={() => handleLoginClick("staff")}
              colorScheme="iTeal" // [ปรับปรุง] ใช้ color scheme จาก theme เพื่อความสอดคล้อง
            >
              เข้าสู่ระบบสำหรับเจ้าหน้าที่
            </Button>
          </VStack>
        )}
      </HStack>
    </Box>
  );
};

export default UserLoginBox;
